import { Fragment, useEffect, useState, useMemo } from "react";
import "./user_edit_profile_content_component.scss";
import images from "../../../../utilities/images/images";
import { isEmpty } from "../../../../custom_utilities/custom_useful_functions";
import axios from "axios";
import {
  url_3,
  url_4,
  url_6,
  url_8,
  url_60,
  url_32,
} from "../../../../custom_utilities/api_services";

//Redux
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";
import authActions from "../../../../redux/auth/action";
import userPreferenceActions from "../../../../redux/user_preference/action";
import moment from "moment";
import RefundContainer from "../refund_modal/RefundContainer";
import {
  setCurrentRefundPackage,
  clearRefundPackage,
} from "../../../../redux/packages_store/refund/RefundPackageSlice";
import RefundSuccessModal from "../refund_modal/RefundSuccessModal";
import { useLocation } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import HeaderLeft from "../../structure_components/desktop_screens/header_component_two/header_left/header_left";
import Header_left from "../../structure_components/desktop_screens/header_component/header_left/header_left";
import FeeDetails from "./fee-details/FeeDetails";

const UserEditProfileContentComponent = (props) => {
  const location = useLocation();

  const [state, setState] = useState({
    userDetails: {
      profileImageDetails: {
        imageData: {},
        localImageURL: "",
        serverImageURL: "",
      },
      fullName: "",
      date_of_birth: "",
      roll_no: "",
      gender: "",
      email: "",
      email_valid: true,
      state: "",
      city: "",
      mobile_number: "",
      acps_pin: "",
      acps_pin_invalid: false,
    },
    states: {},
    cities: {},
    buyPackageList: [],
    editToggle: false,
    isRefundModalOpen: false,
    isRefundSuccessModalOpen: false,
    tab: location?.state?.tab?.length ? location.state.tab : "profile",
  });

  const { tab } = state;

  let {
    history,
    userPreference,
    startLoading,
    finishLoading,
    setUser,
    setUserPreference,
    token,
    tokenType,
    currentRefundPackage,
  } = props;
  const [subTab, setSubTab] = useState("active");
  const [isActive, setIsActive] = useState(true);
  const [batchId, setBatchId] = useState(null);

  useEffect(() => {
    getUserData();
    getStates();
  }, []);
  useEffect(() => {
    getBuypackage();
  }, [isActive]);

  const getBuypackage = async () => {
    startLoading();
    try {
      const response = await axios.get(
        `https://learning.motion.ac.in/motioneducation/api/v1/user/packages/handbook?active=${isActive}`
      );
      if (response.data.status === 200) {
        finishLoading();
        console.log("list of packages", response.data.data);

        setState((prevState) => ({
          ...prevState,
          buyPackageList: [...response.data.data],
        }));
      } else {
        finishLoading();
        alert(response.data.message);
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };
  const getUserData = async () => {
    try {
      const response = await axios.get(url_8);
      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            fullName: response.data.data.name,
            date_of_birth: response.data.data.dob,
            mobile_number: response.data.data.mobile,
            gender: response.data.data.gender,
            email: response.data.data.email,
            state: response.data.data.address.state,
            city: response.data.data.address.city,
            roll_no: response.data.data.roll_no,
            acps_pin: response.data.data.acps_pin,
            profileImageDetails: {
              ...prevState.userDetails.profileImageDetails,
              serverImageURL: response.data.data.image,
            },
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getStates = async () => {
    if (window.navigator.onLine) {
      try {
        const response = await axios.get(url_3);

        if (response.data.status === 200) {
          setState((prevState) => ({
            ...prevState,
            states: response.data.data,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      alert("Please check your internet connection");
    }
  };

  const getCities = async (selectedState) => {
    let state = selectedState;
    startLoading();
    try {
      const response = await axios.get(`${url_4}?state=${state}`);

      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          cities: response.data.data,
        }));
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const createImageLocalURL = (imageDetails) => {
    let objectURL = URL.createObjectURL(imageDetails);
    return objectURL;
  };

  const handleProfileImage = (event) => {
    let userDetails = { ...state.userDetails };
    let profileImageDetails = { ...userDetails.profileImageDetails };
    let { files } = event.target;
    let localImageURL = createImageLocalURL(files[0]);

    profileImageDetails.imageData = files[0];
    profileImageDetails.localImageURL = localImageURL;

    setState((prevState) => ({
      ...prevState,
      userDetails: {
        ...prevState.userDetails,
        profileImageDetails: profileImageDetails,
      },
    }));
  };

  const handleUpdateFormField = (event) => {
    let { name, value } = event.target;

    switch (name) {
      case "fullName":
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            fullName: value.replace(/[^A-Za-z ]/g, ""),
          },
        }));
        break;
      case "date_of_birth":
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            date_of_birth: value,
          },
        }));
        break;
      case "gender":
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            gender: value,
          },
        }));
        break;

      case "roll_no":
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            roll_no: value,
          },
        }));
        break;

      case "email":
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            email: value.replace(/[^A-Za-z0-9+-.~_@]/g, ""),
            email_valid: /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
              value
            ),
          },
        }));
        break;
      case "acps_pin":
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            acps_pin: value.slice(0, 4),
            acps_pin_invalid:
              value.slice(0, 4).toString().length !== 4 ||
              value.slice(0, 4).toString() === "0000",
          },
        }));
        break;
      case "mobile_number":
        setState((prevState) => ({
          ...prevState,
          userDetails: {
            ...prevState.userDetails,
            mobile_number: value,
          },
        }));
        break;
      default:
        break;
    }
  };

  const handleStateDropdown = (event) => {
    let { value } = event.target;
    setState((prevState) => ({
      ...prevState,
      userDetails: { ...prevState.userDetails, state: value, city: "" },
    }));

    getCities(value);
  };
  const handleGenderDropdown = (event) => {
    let { value } = event.target;
    setState((prevState) => ({
      ...prevState,
      userDetails: { ...prevState.userDetails, gender: value },
    }));

    getCities(value);
  };

  const handleCityDropdown = (event) => {
    let { value } = event.target;

    setState((prevState) => ({
      ...prevState,
      userDetails: { ...prevState.userDetails, city: value },
    }));
  };
  console.log("ab:", userPreference);

  const handleSubmitUpdateForm = async (event) => {
    event.preventDefault();
    let userDetails = { ...state.userDetails };

    if (window.navigator.onLine) {
      startLoading();
      let formData = new FormData();

      formData.append("name", userDetails.fullName);
      formData.append("dob", userDetails.date_of_birth);
      formData.append("gender", userDetails.gender);
      formData.append("roll_no", userDetails.roll_no);
      formData.append("state", userDetails.state);
      formData.append("mobile_number", userDetails.mobile_number);
      formData.append("city", userDetails.city);
      if (userDetails.email) {
        formData.append("email", userDetails.email);
      }

      if (userDetails.profileImageDetails.localImageURL.length) {
        formData.append("image", userDetails.profileImageDetails.imageData);
      }

      if (userDetails.acps_pin >= 1000) {
        formData.append("acps_pin", userDetails.acps_pin);
      }

      formData.append(
        "user_target_id",
        userPreference.targetDetails[0].target_id
      );
      let courseId = [userPreference.courseDetails[0].course_id];
      formData.append("target_ids", JSON.stringify(courseId)); /////Course Id

      formData.append("class_id", userPreference.classDetails.class_id);
      formData.append("batch_id", userPreference.batchDetails.batch_id);

      let returnedResponse = await updateProfileApi(formData);

      if (returnedResponse.result === 1) {
        finishLoading();
        setUser(returnedResponse.data.apiData);
        //////set user preference////////
        setUserPreference({
          targetDetails: returnedResponse.data.apiData.UsertargetDetail,
          courseDetails: returnedResponse.data.apiData.targets,
          classDetails: {
            class_id: returnedResponse.data.apiData.class_id,
            class: returnedResponse.data.apiData.class,
          },
          batchDetails: {
            batch_id: returnedResponse.data.apiData.batch_id,
            batch: returnedResponse.data.apiData.batch,
          },
        });
      } else {
        finishLoading();
        alert(returnedResponse.data.message);
      }
    } else {
      alert("Please check your internet connection");
    }
  };

  const updateProfileApi = async (formData) => {
    try {
      const response = await axios.post(url_6, formData);
      if (response.status === 200) {
        if (response.data.status === 200) {
          return {
            result: 1,
            data: {
              message: response.data.message,
              apiData: response.data.data,
            },
          };
        } else {
          return { result: 0, data: { message: response.data.message } };
        }
      } else {
        return { result: 0, data: { message: "Something went wrong!!!" } };
      }
    } catch (error) {
      console.log(error.response);
      return {
        result: 0,
        data: { message: error.response.statusText },
      };
    }
  };
  const handleRedirect = () => {
    history.push("/user_dashboard");
  };

  const editButton = () => {
    setState((prevState) => ({
      ...prevState,
      editToggle: !prevState.editToggle,
    }));
  };

  const handleCloseRefundModal = () => {
    setState((prevState) => ({
      ...prevState,
      isRefundModalOpen: false,
    }));
  };

  const handleOpenRefundSuccessModal = () => {
    setState((prevState) => ({
      ...prevState,
      isRefundSuccessModalOpen: true,
    }));
  };

  const handleCloseRefundSuccessModal = () => {
    setState((prevState) => ({
      ...prevState,
      isRefundSuccessModalOpen: false,
    }));

    window.location.reload();
  };

  const refunduseMemo = useMemo(() => {
    return (
      <RefundContainer
        closeRefundModal={handleCloseRefundModal}
        isRefundModalOpen={state.isRefundModalOpen}
        startLoading={startLoading}
        finishLoading={finishLoading}
        token={token}
        tokenType={tokenType}
        currentRefundPackage={currentRefundPackage}
        openRefundSuccessModal={handleOpenRefundSuccessModal}
      />
    );
  }, [state.isRefundModalOpen]);

  const handleTab = (tab) => {
    setState((prevState) => {
      return {
        ...prevState,
        tab,
      };
    });
  };

  const filteredPackages = state.buyPackageList;

  const handleAccessClick = async (selectedPackage) => {
    const courseDetail = userPreference.courseDetails.find(
      (item) => item.course_id === selectedPackage.course_id
    );

    const courseData = courseDetail
      ? {
          course_id: courseDetail.course_id,
          course: courseDetail.course,
        }
      : {
          course_id: selectedPackage.course_id,
          course: selectedPackage.coursename,
        };

    const updatedPreference = {
      targetDetails: userPreference.targetDetails,
      classDetails: userPreference.classDetails,
      courseDetails: [courseData],
      batchDetails: {
        batch_id: selectedPackage.batch_id,
        batch: selectedPackage.batch || "Batch",
      },
    };

    const apiPayload = {
      user_target_id: updatedPreference.targetDetails[0].target_id,
      class_id: updatedPreference.classDetails.class_id,
      course_id: updatedPreference.courseDetails[0].course_id,
      batch_id: updatedPreference.batchDetails.batch_id,
    };

    try {
      startLoading();
      const response = await axios.post(url_32, apiPayload);

      if (response.status === 200 && response.data.status === 200) {
        finishLoading();

        setUser(response.data.data);
        setUserPreference({
          targetDetails: response.data.data.UsertargetDetail,
          classDetails: {
            class_id: response.data.data.class_id,
            class: response.data.data.class,
          },
          courseDetails: response.data.data.targets,
          batchDetails: {
            batch_id: response.data.data.batch_id,
            batch: response.data.data.batch,
          },
        });

        setBatchId(response.data.data.batch_id);
        history.push("/user_dashboard");
      } else {
        finishLoading();
        alert(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      finishLoading();
      console.error("API error:", error);
      alert("Error updating course preference.");
    }
  };

  return (
    <Fragment>
      <HeaderLeft
        batchId={batchId}
        userPreference={userPreference}
        setUserPreference={setUserPreference}
        setUser={setUser}
      />

      <div className="userEditProfileContentComponent_wrapper">
        <div className="container">
          <div className="userEditProfileContentComponent_inner_wrapper">
            <div className="back_btn">
              <button onClick={() => handleRedirect()}>
                <img src={images.login_2} alt="" />
              </button>
            </div>
            <form onSubmit={(event) => handleSubmitUpdateForm(event)}>
              <div className="content_wrapper">
                <div className="image_content_wrapper">
                  <div className="image_wrapper">
                    <div className="image_inner_wrapper">
                      {state.userDetails.profileImageDetails.localImageURL
                        .length ? (
                        <img
                          alt=""
                          className="dummy_image"
                          src={
                            state.userDetails.profileImageDetails.localImageURL
                          }
                        />
                      ) : state.userDetails.profileImageDetails.serverImageURL
                          .length ? (
                        <img
                          alt=""
                          className="dummy_image"
                          src={
                            state.userDetails.profileImageDetails.serverImageURL
                          }
                        />
                      ) : (
                        <img
                          className="dummy_image"
                          alt=""
                          src={images.signUp_1}
                        />
                      )}

                      <label className="custom-file-upload">
                        <input
                          type="file"
                          name="profileImage"
                          id="upload_image"
                          accept="image/*"
                          onChange={(event) => handleProfileImage(event)}
                        />
                        <span>Replace</span>
                      </label>
                    </div>
                  </div>
                </div>
                <ul class="nav nav-tabs tab_button" id="myTab" role="tablist">
                  <li
                    class="nav-item"
                    role="presentation"
                    onClick={() => handleTab("profile")}
                  >
                    <button
                      className={
                        tab == "profile" ? "nav-link active" : "nav-link"
                      }
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      Profile
                    </button>
                  </li>
                  <li
                    class="nav-item"
                    role="presentation"
                    onClick={() => handleTab("packages")}
                  >
                    <button
                      className={
                        tab == "packages" ? "nav-link active" : "nav-link"
                      }
                      id="packages-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#packages"
                      type="button"
                      role="tab"
                      aria-controls="packages"
                      aria-selected="false"
                    >
                      My packages
                    </button>
                  </li>
                  <li
                    class="nav-item"
                    role="presentation"
                    onClick={() => handleTab("fee-details")}
                  >
                    <button
                      className={
                        tab == "fee-details" ? "nav-link active" : "nav-link"
                      }
                      id="fee-details-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#fee-details"
                      type="button"
                      role="tab"
                      aria-controls="fee-details"
                      aria-selected="false"
                    >
                      Fee Details
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div
                    className={
                      tab == "profile"
                        ? "tab-pane fade show active"
                        : "tab-pane fade"
                    }
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="user_detail_box">
                      <div className="title_edit">
                        <h3>Personal information</h3>
                        <button type="button" onClick={editButton}>
                          <i className="far fa-edit"></i>
                        </button>
                      </div>
                      <div className="input_wrp_box">
                        <div className="input_wrapper">
                          <div>
                            <label for="fullName">Name</label>
                          </div>
                          <input
                            type="text"
                            name="fullName"
                            id="fullName"
                            value={state.userDetails.fullName}
                            placeholder="Name"
                            onChange={(event) => handleUpdateFormField(event)}
                            disabled={!state.editToggle}
                          />
                          <p
                            style={{ display: "none" }}
                            className={
                              state.userDetails.fullName || !state.editToggle
                                ? ``
                                : `error_text`
                            }
                          >
                            Please enter your name
                          </p>
                        </div>
                        <div className="input_wrapper">
                          <div>
                            <label for="mobile_number">Mobile</label>
                          </div>
                          <input
                            type="text"
                            name="mobile_number"
                            id="mobile_number"
                            value={state.userDetails.mobile_number}
                            onChange={(event) => handleUpdateFormField(event)}
                            placeholder="Mobile number"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="input_wrp_box">
                        <div className="input_wrapper">
                          <label for="date_of_birth">Date of Birth</label>
                          <input
                            type="date"
                            name="date_of_birth"
                            id="date_of_birth"
                            value={state.userDetails.date_of_birth}
                            placeholder="Date of Birth"
                            onChange={(event) => handleUpdateFormField(event)}
                            disabled={!state.editToggle}
                            required
                          />
                        </div>
                        <div className="input_wrapper">
                          <div>
                            <label for="email">Email id</label>
                          </div>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            value={state.userDetails.email}
                            placeholder="Email id"
                            onChange={(event) => handleUpdateFormField(event)}
                            disabled={!state.editToggle}
                          />
                          <p
                            style={{ display: "none" }}
                            className={
                              state.userDetails.email_valid || !state.editToggle
                                ? ``
                                : `error_text`
                            }
                          >
                            Please enter a valid email
                          </p>
                        </div>
                      </div>
                      <div className="input_wrp_box">
                        <div className="select_wrapper">
                          <div>
                            <label for="state">State</label>
                          </div>
                          <select
                            id="state"
                            defaultValue={state.userDetails.state}
                            defaultChecked={state.userDetails.state}
                            onChange={(event) => handleStateDropdown(event)}
                            disabled={!state.editToggle}
                          >
                            <option value="" disabled>
                              {state.userDetails.state
                                ? state.userDetails.state
                                : "Select State"}
                            </option>
                            {!isEmpty(state.states)
                              ? state.states.states.map((element, index) => {
                                  return (
                                    <option key={index} value={element}>
                                      {element}
                                    </option>
                                  );
                                })
                              : null}
                          </select>
                        </div>

                        <div className="select_wrapper">
                          <div>
                            <label for="city">City</label>
                          </div>
                          <select
                            id="city"
                            defaultValue={state.userDetails.city}
                            onChange={(event) => handleCityDropdown(event)}
                            disabled={!state.editToggle}
                          >
                            <option value="" disabled>
                              {state.userDetails.city
                                ? state.userDetails.city.length
                                  ? state.userDetails.city
                                  : "Select City"
                                : "Select City"}
                            </option>
                            {!isEmpty(state.cities)
                              ? state.cities.districts.map((element, index) => {
                                  return (
                                    <option key={index} value={element}>
                                      {element}
                                    </option>
                                  );
                                })
                              : null}
                          </select>
                        </div>
                      </div>
                      <div className="input_wrp_box">
                        <div className="select_wrapper">
                          <div>
                            <label for="gender">Gender</label>
                          </div>
                          <select
                            id="gender"
                            value={state.userDetails.gender}
                            defaultChecked={state.userDetails.gender}
                            onChange={(event) => handleGenderDropdown(event)}
                            disabled={!state.editToggle}
                          >
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div className="input_wrapper">
                          <div>
                            <label for="acps_pin">ACPS pin</label>
                          </div>
                          <input
                            type="number"
                            max={9999}
                            name="acps_pin"
                            id="acps_pin"
                            value={state.userDetails.acps_pin}
                            placeholder="ACPS pin"
                            onChange={(event) => handleUpdateFormField(event)}
                            disabled={!state.editToggle}
                          />
                          <p
                            className={
                              state.userDetails.acps_pin_invalid
                                ? `error_text`
                                : ``
                            }
                            style={{ display: "none" }}
                          >
                            ACPS pin should have 4 digits
                          </p>
                        </div>
                      </div>
                      <div className="input_wrp_box">
                        {state.userDetails.roll_no && (
                          <div className="input_wrapper">
                            <div>
                              <label for="roll_no">Roll No</label>
                            </div>
                            <input
                              type="number"
                              min="1"
                              name="roll_no"
                              id="roll_no"
                              value={state.userDetails.roll_no}
                              disabled
                            />
                          </div>
                        )}
                      </div>

                      <div className="btn_wrapper">
                        <button type="submit">Update Changes</button>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab == "packages"
                        ? "tab-pane fade show active"
                        : "tab-pane fade"
                    }
                    id="packages"
                    role="tabpanel"
                    aria-labelledby="packages-tab"
                  >
                    {tab === "packages" && (
                      <div className="sub-tab-wrapper">
                        <ul className="sub-tab-list">
                          <li
                            className={
                              subTab === "active" ? "sub-tab active" : "sub-tab"
                            }
                            onClick={() => {
                              setSubTab("active");
                              setIsActive(true);
                            }}
                          >
                            Active Packages
                          </li>
                          <li
                            className={
                              subTab === "expired"
                                ? "sub-tab active"
                                : "sub-tab"
                            }
                            onClick={() => {
                              setSubTab("expired");
                              setIsActive(false);
                            }}
                          >
                            Expired Packages
                          </li>
                        </ul>
                      </div>
                    )}
                    {console.log("txn", filteredPackages)}
                    {!isEmpty(state.buyPackageList) ? (
                      <div className="your_package_list">
                        <div className="current_package">
                          <div className="crnt_pckgeBx_wrpr">
                            {filteredPackages.length ? (
                              filteredPackages.map((element, index) => {
                                if (element.type === "online") {
                                  return (
                                    <div
                                      key={index}
                                      className="crnt_pckge_box"
                                      style={{ marginBottom: "20px" }}
                                    >
                                      <div className="d-flex justify-content-between align-items-start">
                                        <div className="course-heading">
                                          {element.package_name}
                                        </div>
                                        <div>
                                          <button
                                            className="details-btn"
                                            onClick={() =>
                                              history.push(
                                                `/package/${element?.package_id}`
                                              )
                                            }
                                          >
                                            View details
                                          </button>
                                        </div>
                                      </div>

                                      <div className="package_coursename">
                                        {element.coursename}
                                      </div>

                                      <div
                                        className="d-flex justify-content-between align-items-center"
                                        style={{ marginTop: "15px" }}
                                      >
                                        <div className="expiry-date">
                                          <p>
                                            {isActive
                                              ? "Expiring on"
                                              : "Expired on"}
                                          </p>

                                          <p>
                                            {moment(
                                              element.txn_expire_date
                                            ).format("DD-MM-YYYY")}
                                          </p>
                                        </div>

                                        {!isActive ? (
                                          <button
                                            className="access-now-btn"
                                            onClick={() =>
                                              history.push(
                                                `/package/${element?.package_id}`
                                              )
                                            }
                                          >
                                            Buy Now
                                          </button>
                                        ) : (
                                          <button
                                            className="access-now-btn"
                                            onClick={() =>
                                              handleAccessClick(element)
                                            }
                                          >
                                            Access Now
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div
                                      key={index}
                                      className="crnt_pckge_box"
                                      style={{ marginBottom: "20px" }}
                                    >
                                      <div className="card-type">
                                        {element.type}
                                      </div>
                                      <div className="course-heading">
                                        {element.product_name}
                                      </div>
                                      <div
                                        className="package_target"
                                        style={{ margin: "10px 0 15px" }}
                                      >
                                        {element.target}
                                      </div>
                                      <div className="d-flex justify-content-between">
                                        <div
                                          className={`order-status-handbook ${
                                            element.order_status === "Failed"
                                              ? "order_failed"
                                              : ""
                                          }`}
                                        >
                                          Order Status{" "}
                                          <span
                                            className={
                                              element.order_status === "Failed"
                                                ? "order_failed"
                                                : ""
                                            }
                                          >
                                            {element.order_status}
                                          </span>
                                        </div>
                                        <div>
                                          <button
                                            className="details-btn"
                                            onClick={() =>
                                              history.push({
                                                pathname: "/orderStatus",
                                                state: {
                                                  orderStatus: element,
                                                },
                                              })
                                            }
                                          >
                                            View Details
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })
                            ) : (
                              <div className="no_dataFind">
                                <div className="img_box">
                                  <img src={images.m2_store} alt="home" />
                                </div>
                                <h5>No Packages yet!</h5>
                                <p>
                                  You haven't purchased any course packages yet!
                                  please go and purchase a right package for you
                                </p>
                                <button
                                  type="button"
                                  onClick={() => history.push(`/store`)}
                                >
                                  Go Store
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="no_dataFind">
                        <div className="img_box">
                          <img src={images.m2_store} alt="home" />
                        </div>
                        <h5>No Packages yet!</h5>
                        <p>
                          You haven't purchased any course packages yet! please
                          go and purchase a right package for you
                        </p>
                        <button
                          type="button"
                          onClick={() => history.push(`/store`)}
                        >
                          Go Store
                        </button>
                      </div>
                    )}
                  </div>

                  <div
                    className={
                      tab == "fee-details"
                        ? "tab-pane fade show active"
                        : "tab-pane fade"
                    }
                    id="fee-details"
                    role="tabpanel"
                    aria-labelledby="fee-details-tab"
                  >
                    <FeeDetails />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {state.isRefundModalOpen && refunduseMemo}

      {state.isRefundSuccessModalOpen && (
        <RefundSuccessModal
          closeRefundSuccessModal={handleCloseRefundSuccessModal}
          isRefundSuccessModalOpen={state.isRefundSuccessModalOpen}
          startLoading={startLoading}
          finishLoading={finishLoading}
          token={token}
          tokenType={tokenType}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.authToken,
    tokenType: state.auth.authType,
    currentRefundPackage: state.RefundPackageSliceReducer.refundCurrentPackage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUser: (payload) => {
      dispatch(authActions.setUser(payload));
    },
    setUserPreference: (payload) => {
      dispatch(userPreferenceActions.setUserPreference(payload));
    },

    setCurrentRefundPackage: (payload) => {
      dispatch(setCurrentRefundPackage(payload));
    },

    clearRefundPackage: () => {
      dispatch(clearRefundPackage());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserEditProfileContentComponent);
